import { styled } from '@linaria/react'
import { Button } from 'atoms/Button'
import { COLOR } from 'vars/color'
import { CORNERS, FIXED_INDENTS, MEDIA, SHADOW } from 'vars/index'

export const CloseButtonSC = styled(Button)``

export const NotificationToastContainerSC = styled.div`
  position: fixed;
  top: var(${FIXED_INDENTS.INDENT_200});
  right: var(${FIXED_INDENTS.INDENT_40});
  left: var(${FIXED_INDENTS.INDENT_40});
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_30});
  pointer-events: none;

  ${MEDIA.MIN_600} {
    width: 386px;
    right: var(${FIXED_INDENTS.INDENT_80});
    left: initial;
  }

  ${MEDIA.MIN_1024} {
    width: 500px;
  }

  ${MEDIA.MIN_1240} {
    top: var(${FIXED_INDENTS.INDENT_260});
    right: var(${FIXED_INDENTS.INDENT_160});
  }

  ${MEDIA.MIN_1920} {
    top: var(${FIXED_INDENTS.INDENT_300});
    right: var(${FIXED_INDENTS.INDENT_200});
  }
`

export const NotificationToastSC = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: var(${FIXED_INDENTS.INDENT_40}) var(${FIXED_INDENTS.INDENT_80})
    var(${FIXED_INDENTS.INDENT_40}) var(${FIXED_INDENTS.INDENT_40});
  border-radius: var(${CORNERS.CORNERS_20});
  background: var(${COLOR.SURFACE_CONSTANT_LIGHT});
  box-shadow: var(${SHADOW.TOAST});
  gap: var(${FIXED_INDENTS.INDENT_30});
  pointer-events: auto;
  animation: slideIn 0.3s ease-out;

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_50}) var(${FIXED_INDENTS.INDENT_80})
      var(${FIXED_INDENTS.INDENT_50}) var(${FIXED_INDENTS.INDENT_50});
    gap: var(${FIXED_INDENTS.INDENT_40});
  }

  ${MEDIA.MIN_1240} {
    padding: var(${FIXED_INDENTS.INDENT_60}) var(${FIXED_INDENTS.INDENT_80})
      var(${FIXED_INDENTS.INDENT_60}) var(${FIXED_INDENTS.INDENT_60});
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  ${CloseButtonSC} {
    position: absolute;
    top: 0;
    right: 0;
    padding: var(${FIXED_INDENTS.INDENT_20});
  }
`

export const NotificationToastIconSC = styled.div``

export const NotificationToastMessageSC = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`
